import React from "react";

import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import {
    ColumnLayout,
    SubColumnLayout,
    ColumnLayoutProps
} from "@/libraries/design/foundations";

const slotWrapper = ({ items }: UniformSlotWrapperComponentProps) => {
    return items.map((element, index) => {
        return <li key={index}>{element}</li>;
    });
};

// Compiled styling requires complex set of choices
export const UniformColumnLayout: React.FC<ColumnLayoutProps> = ({
    layout = "12",
    paddingTopv2,
    paddingBottomv2,
    verticalAlignment = "normal",
    renderAsList
}) => {
    return (
        <ColumnLayout
            layout={layout}
            paddingTopv2={paddingTopv2}
            paddingBottomv2={paddingBottomv2}
            verticalAlignment={verticalAlignment}
            renderAsList={renderAsList}
        >
            {
                <UniformSlot
                    name="content"
                    wrapperComponent={renderAsList ? slotWrapper : undefined}
                />
            }
        </ColumnLayout>
    );
};

// Compiled styling requires complex set of choices
export const UniformSubColumnLayout: React.FC<ColumnLayoutProps> = ({
    layout = "12",
    paddingTopv2,
    paddingBottomv2,
    verticalAlignment = "normal",
    renderAsList
}) => {
    return (
        <SubColumnLayout
            layout={layout}
            paddingTopv2={paddingTopv2}
            paddingBottomv2={paddingBottomv2}
            verticalAlignment={verticalAlignment}
            renderAsList={renderAsList}
        >
            {
                <UniformSlot
                    name="content"
                    wrapperComponent={renderAsList ? slotWrapper : undefined}
                />
            }
        </SubColumnLayout>
    );
};

// Both components are exported as named exports above
